module.exports = __webpack_public_path__ + "img/xzht1.e7a96634.png";